import {Component, OnDestroy, OnInit, inject} from '@angular/core';
import {AuthenticationService} from '@core/auth';
import {catchError, take} from 'rxjs/operators';
import {EMPTY, Subscription} from 'rxjs';
import {OctDocumentService} from '@services/document';
import {Router} from '@angular/router';

@Component({
  selector: 'oct-sso',
  templateUrl: './sso.component.html'
})
export class SsoComponent implements OnInit, OnDestroy {
  private readonly _authenticationService = inject(AuthenticationService);
  private readonly _document = inject(OctDocumentService);
  private readonly _router = inject(Router);

  isAuth0 = false;
  connectorsList = [];
  private readonly _subs = new Subscription();

  ngOnInit() {
    this._getAuthClientData();
  }

  private _getAuthClientData() {
    this._subs.add(
      this._authenticationService
        .getClientData(this._document.activeCompanyPrefix())
        .pipe(
          take(1),
          catchError(() => {
            this.isAuth0 = false;
            return EMPTY;
          })
        )
        .subscribe(({connectors, clientId, domain}) => {
          this._authenticationService.authSubject.next({clientId, domain});
          this.connectorsList = connectors;
          this.isAuth0 = true;
          const data = this.connectorsList.find(item => item.name === 'google-oauth2');
          if (!data) {
            this._router.navigate(['/loginredirect']);
            return;
          }
        })
    );
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
